/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const EventBehaviorType = {
	SendFeedback: 'SendFeedback',
	ConfirmPicturesUploaded: 'ConfirmPicturesUploaded',
	SendOfferFeedback: 'SendOfferFeedback',
	ChangeDamageDescription: 'ChangeDamageDescription',
	RedirectToAnotherPage: 'RedirectToAnotherPage',
	SendQuestionsAnswers: 'SendQuestionsAnswers',
} as const;
export type EventBehaviorType = (typeof EventBehaviorType)[keyof typeof EventBehaviorType];

export function instanceOfEventBehaviorType(value: any): boolean {
	for (const key in EventBehaviorType) {
		if (Object.prototype.hasOwnProperty.call(EventBehaviorType, key)) {
			if (EventBehaviorType[key as keyof typeof EventBehaviorType] === value) {
				return true;
			}
		}
	}
	return false;
}

export function EventBehaviorTypeFromJSON(json: any): EventBehaviorType {
	return EventBehaviorTypeFromJSONTyped(json, false);
}

export function EventBehaviorTypeFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): EventBehaviorType {
	return json as EventBehaviorType;
}

export function EventBehaviorTypeToJSON(value?: EventBehaviorType | null): any {
	return value as any;
}

export function EventBehaviorTypeToJSONTyped(
	value: any,
	ignoreDiscriminator: boolean
): EventBehaviorType {
	return value as EventBehaviorType;
}
